/*
 * @Author: Chao Yang
 * @Date: 2019-12-26 10:38:32
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-20 15:09:39
 */
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'ad-modal',
  templateUrl: './ad-modal.component.html',
  styleUrls: ['./ad-modal.component.scss']
})
export class AdModalComponent implements OnInit {
  _open: boolean;
  @Input()
  autoClose = true;
  @Output()
  display = new EventEmitter();
  @Output()
  hide = new EventEmitter();
  @Input()
  set open(value: boolean) {
    if (this.open !== value) {
      this._open = value;
      if (value) {
        this.display.emit();
      } else {
        this.hide.emit();
      }
    }
  }
  get open() {
    return this._open;
  }
  @ViewChild('overlay', { static: true })
  overlay: ElementRef;
  @Input()
  width: number;

  constructor() {}

  clickOverlay(e: Event): void {
    if (e.target === this.overlay.nativeElement) {
      if (this.autoClose === true) {
        e.preventDefault();
        e.stopPropagation();
        this.open = false;
      }
    }
  }

  ngOnInit(): void {
    if (this.width === undefined) {
      this.width = 500;
    }
  }
}
